<script setup lang="ts">
import { MMPopupControllerTarget, usePopups } from '@mm-frontend/mm-web-ui-kit';
import { DevToolbar } from '@/features/dev-toolbar/ui';
import { SnackbarContainer } from '@/features/ui-kit';
import { isDevBuildMode } from '#shared/helpers/buildMode';
import { CookieAcceptPopup } from '@/features/cookie-accept-popup';
import { useLegalSDK } from './features/legal-sdk';
import { useB2BCookieController } from './features/cookie-controller';
import { CanaryCookieController } from './shared/helpers/CanaryCookieController';
import { ELocalStorageKeys } from '@/features/store/ELocalStorageKeys';

useLegalSDK();
useB2BCookieController();

onMounted(() => {
  // Из-за возможной несовместимости данных между старой (KE-CUSTOMERS) и новой (MM-WEB)
  // версиями сайта при переходе на новую версию, проверяем наличие ключа миграции в localStorage.
  // Если ключ отсутствует, это означает, что пользователь впервые попадает на новую версию,
  // и мы очищаем localStorage и sessionStorage, чтобы стереть данные старой версии,
  // которые могут быть несовместимы с новой версией. После очистки устанавливаем ключ,
  // чтобы в следующий раз не очищать хранилища.
  const migrationKey = ELocalStorageKeys.MM__MM_WEB_MIGRATION_COMPLETE;
  if (!localStorage.getItem(migrationKey)) {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem(migrationKey, 'true');
  }
  // Устанавливаем куку для привязки пользователя к новой версии (MM-WEB)
  // Это гарантирует, что пользователь, попавший на новую версию, останется на ней
  CanaryCookieController.enableNewVersion();
});

const { closeAllPopups } = usePopups();
const route = useRoute();
watch(
  () => route.path,
  () => closeAllPopups()
);
</script>

<template>
  <NuxtRouteAnnouncer />
  <NuxtLayout>
    <DevToolbar v-if="isDevBuildMode()" />
    <NuxtPage />

    <ClientOnly>
      <MMPopupControllerTarget />
      <SnackbarContainer />
      <CookieAcceptPopup />
    </ClientOnly>
  </NuxtLayout>
</template>

<style lang="stylus">
body
  font-family: 'Inter', sans-serif;
  margin: 0;
  width 100%
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
</style>
